/* eslint-disable jsx-a11y/click-events-have-key-events */
'use client';
import { useEffect, useMemo, useState } from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { DownArrowIcon, UpArrowIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useDevice } from '@contexts/device';
import { StaticPagesSidebarListingItemViewModel } from '@api/v3';
import { useQueryParams } from '@hooks/useQueryParams';

import {
  Text,
  ItemContainer,
  Separate,
  SidebarContainer,
  SidebarContent,
  Title,
  TitleWrapper,
  Wrapper,
  ParentSidebar,
} from './styled';
import SidebarChild from './SidebarChild';

export type MenuItemEventType = {
  slug?: string;
  path: { title?: string; url?: string }[];
  title?: string;
  links?: boolean;
};
export interface Props {
  item: StaticPagesSidebarListingItemViewModel;
  staticPageSubPath: string;
  selected: string[];
  onMenuItemClick?: ({ slug, path, title }: MenuItemEventType) => void;
}
export const SidebarItem = ({
  item,
  selected,
  staticPageSubPath,
  onMenuItemClick,
}: Props) => {
  const { isDesktop } = useDevice();
  const [isSelected, setIsSelected] = useState(false);
  const pathname = usePathname();
  const query = useQueryParams();
  const [open, setOpen] = useState(false);

  const selectedItem = useMemo(() => {
    let targetItem: any;
    item?.links.forEach((subItem) => {
      if (
        subItem.href.split('/')[1] === query.slug ||
        pathname === subItem.href
      ) {
        targetItem = item;
      }
    });
    return targetItem;
  }, [query]);

  useEffect(() => {
    if (item?.slug?.split('/')[1] === query.slug || pathname === item.slug) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }

    item?.links.forEach((subItem) => {
      if (
        subItem.href.split('/')[1] === query?.slug ||
        pathname === subItem.href
      ) {
        setOpen(true);
      }
    });
  }, [query]);
  const onClick = () => {
    setOpen(!open);
  };
  if (item.links.length > 0) {
    return (
      <Wrapper isDesktop={isDesktop}>
        <ParentSidebar isDesktop={isDesktop}>
          <ItemContainer onClick={onClick} isParent={true}>
            <TitleWrapper>
              <Title isColor={selectedItem?.title}>{item.title}</Title>
            </TitleWrapper>
            {item.links.length > 0 ? (
              <CustomIcon
                icon={open ? UpArrowIcon : DownArrowIcon}
                fontSize={16}
                paletteColor='black'
              />
            ) : null}
          </ItemContainer>
          <Separate isParent={true} />
          <SidebarContent open={open}>
            {item?.links?.map((child, index) => (
              // eslint-disable-next-line jsx-a11y/no-static-element-interactions
              <div
                onClick={() =>
                  onMenuItemClick?.({
                    slug: child.name,
                    path: [{ title: child.name, url: child.href }],
                    title: child.name,
                  })
                }
                key={child.href || index}
              >
                <SidebarChild
                  item={child}
                  selected={String(selected)}
                  staticPageSubPath={staticPageSubPath}
                />
              </div>
            ))}
          </SidebarContent>
        </ParentSidebar>
      </Wrapper>
    );
  } else {
    return (
      <>
        <Wrapper isDesktop={isDesktop}>
          <SidebarContainer isDesktop={isDesktop}>
            <ItemContainer>
              <TitleWrapper>
                <Link
                  href={
                    item.slug === '/logout'
                      ? '/'
                      : staticPageSubPath + item.slug
                  }
                  prefetch={false}
                >
                  <Text isColor={isSelected}>{item.title}</Text>
                </Link>
              </TitleWrapper>
            </ItemContainer>
            <Separate isColor={isSelected} />
          </SidebarContainer>
        </Wrapper>
      </>
    );
  }
};
export default SidebarItem;
